import * as React from 'react'

const WheelRays = props => (
  <svg
    viewBox="0 0 819 819"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}>
    <g opacity="0.2">
      <path
        d="M368.926 0H450.078L409.506 409.504L368.926 0Z"
        fill="url(#paint0)"
      />
      <path
        d="M169.609 75.1466L239.891 34.5742L409.502 409.503L169.609 75.1466Z"
        fill="url(#paint1)"
      />
      <path
        d="M34.5781 239.893L75.1505 169.611L409.507 409.504L34.5781 239.893Z"
        fill="url(#paint2)"
      />
      <path
        d="M0 450.076V368.924L409.504 409.504L0 450.076Z"
        fill="url(#paint3)"
      />
      <path
        d="M75.1505 649.389L34.5781 579.115L409.507 409.504L75.1505 649.389Z"
        fill="url(#paint4)"
      />
      <path
        d="M239.891 784.425L169.609 743.853L409.502 409.504L239.891 784.425Z"
        fill="url(#paint5)"
      />
      <path
        d="M450.078 819H368.926L409.506 409.504L450.078 819Z"
        fill="url(#paint6)"
      />
      <path
        d="M649.389 743.853L579.115 784.425L409.504 409.504L649.389 743.853Z"
        fill="url(#paint7)"
      />
      <path
        d="M784.425 579.115L743.853 649.389L409.504 409.504L784.425 579.115Z"
        fill="url(#paint8)"
      />
      <path
        d="M819 368.924V450.076L409.504 409.504L819 368.924Z"
        fill="url(#paint9)"
      />
      <path
        d="M743.853 169.611L784.425 239.893L409.504 409.504L743.853 169.611Z"
        fill="url(#paint10)"
      />
      <path
        d="M579.115 34.5742L649.389 75.1466L409.504 409.503L579.115 34.5742Z"
        fill="url(#paint11)"
      />
    </g>

    <defs>
      <linearGradient
        id="paint0"
        x1="409.502"
        y1="0"
        x2="409.502"
        y2="409.504"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.1" stopColor="#FFFDFB" stopOpacity="0" />
        <stop offset="1" stopColor="#FFFDFB" />
      </linearGradient>

      <linearGradient
        id="paint1"
        x1="204.093"
        y1="46.5931"
        x2="409.499"
        y2="409.499"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.2" stopColor="#FFFDFB" stopOpacity="0" />
        <stop offset="1" stopColor="#FFFDFB" />
      </linearGradient>

      <linearGradient
        id="paint2"
        x1="80.7207"
        y1="224.438"
        x2="409.502"
        y2="409.5"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFFDFB" stopOpacity="0" />
        <stop offset="1" stopColor="#FFFDFB" />
      </linearGradient>

      <linearGradient
        id="paint3"
        x1="31.5"
        y1="409.5"
        x2="409.504"
        y2="409.5"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.1" stopColor="#FFFDFB" stopOpacity="0" />
        <stop offset="1" stopColor="#FFFDFB" />
      </linearGradient>

      <linearGradient
        id="paint4"
        x1="409.502"
        y1="409.5"
        x2="84.6582"
        y2="599.156"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFFDFB" />
        <stop offset="1" stopColor="#FFFDFB" stopOpacity="0" />
      </linearGradient>

      <linearGradient
        id="paint5"
        x1="409.499"
        y1="409.5"
        x2="229.687"
        y2="726.469"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFFDFB" />
        <stop offset="0.9" stopColor="#FFFDFB" stopOpacity="0" />
      </linearGradient>

      <linearGradient
        id="paint6"
        x1="409.502"
        y1="409.504"
        x2="409.502"
        y2="819"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFFDFB" />
        <stop offset="0.95" stopColor="#FFFDFB" stopOpacity="0" />
      </linearGradient>

      <linearGradient
        id="paint7"
        x1="409.499"
        y1="416.063"
        x2="600.468"
        y2="742.875"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFFDFB" />
        <stop offset="0.85" stopColor="#FFFDFB" stopOpacity="0" />
      </linearGradient>

      <linearGradient
        id="paint8"
        x1="409.499"
        y1="409.5"
        x2="738.936"
        y2="596.531"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFFDFB" />
        <stop offset="1" stopColor="#FFFDFB" stopOpacity="0" />
      </linearGradient>

      <linearGradient
        id="paint9"
        x1="409.504"
        y1="409.5"
        x2="786.843"
        y2="409.5"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFFDFB" />
        <stop offset="0.9" stopColor="#FFFDFB" stopOpacity="0" />
      </linearGradient>

      <linearGradient
        id="paint10"
        x1="416.061"
        y1="409.5"
        x2="742.874"
        y2="223.125"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFFDFB" />
        <stop offset="1" stopColor="#FFFDFB" stopOpacity="0" />
      </linearGradient>

      <linearGradient
        id="paint11"
        x1="601.78"
        y1="80.7181"
        x2="409.499"
        y2="409.499"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.15" stopColor="#FFFDFB" stopOpacity="0" />
        <stop offset="1" stopColor="#FFFDFB" />
      </linearGradient>
    </defs>
  </svg>
)

export default WheelRays
